import guidedTourSlice from '.';

export const {
  startTour,
  restartTour,
  pauseTour,
  resumeTour,
  goToStep,
  goBackTo,
  completeTour,
  setFurthestStep,
  dismissMobileWarning,
} = guidedTourSlice.actions;
